export default {
    data: () => ({

    }),
    methods: {
        clearUser () {
            const vm = this
            vm.$store.dispatch('users/clearUser').then(function () {
                vm.$router.replace('login')
            })
        },
        loadNotifications () {
          const vm = this
          vm.$store.dispatch('notifications/loadNotifications').then(() => {
            // console.log('se cargo las notificaciones')
          }, function (err) {
            console.log(err, 'Permision denied error')
          })
        },
        loadNoRead () {
            const vm = this
            vm.$store.dispatch('notifications/loadNoRead').then(() => {
                // console.log('se cargo las notificaciones no leidas')
            }, function (err) {
                vm.$store.dispatch('users/showErrorSessionExpired')
                console.log(err, 'Permision denied error')
            })
        },
        loadProviders () {
            const vm = this
            vm.$store.dispatch('providers/loadItems', 'providers').then(() => {
                console.log('se cargaron los proveedores')
            })
        },
        loadExpenses () {
            const vm = this
            vm.$store.dispatch('expenses/loadItems', 'expenses').then(() => {
                // console.log('se cargaron los gastos')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadBills () {
            const vm = this
            vm.$store.dispatch('bills/loadItems', 'bills').then(() => {
                // console.log('se cargaron los pagos')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadSubscriptions () {
            const vm = this
            vm.$store.dispatch('subscriptions/loadItems', 'subscriptions').then(() => {
                // console.log('se cargaron los subcri')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadProducts () {
            const vm = this
            vm.$store.dispatch('products/loadItems', 'inventory').then(() => {
                // console.log('se cargaron los productos')
            }, function (err) {
                vm.$store.dispatch('users/showErrorSessionExpired')
                console.log(err, 'Permision denied error')
            })
        },
        loadCategories () {
            const vm = this
            vm.$store.dispatch('categories/loadItems', 'categories').then(() => {
                // console.log('se cargaron las categorias')
               // se cargaron las categorias
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadLocations () {
            const vm = this
            vm.$store.dispatch('shops/loadItems', 'shops').then(() => {
                // console.log('se cargaron las tiendas')

               // se cargaron las tiendas
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadAdmins () {
            const vm = this
            vm.$store.dispatch('admins/loadAdmins', 'admins').then(() => {
                // console.log('se cargaron los administradores')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadProfile () {
            const vm = this
            vm.$store.dispatch('users/loadProfile').then((res) => {
                // console.log('se cargo el perfil')
                if (res.showNotifSnack) {
                    vm.$store.dispatch('notifications/listenNewNotifications').then(() => {
                        // console.log('se cargo la ultima notificacion no leida')
                    }, function (err) {
                        vm.$store.dispatch('users/showErrorSessionExpired')
                        console.log(err, 'Permision denied error')
                    })
                }
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadClients () {
            const vm = this
            vm.$store.dispatch('clients/loadClients').then(() => {
                // console.log('se cargaron los clientes')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadCookies () {
            const vm = this
            vm.$store.dispatch('users/loadCookies').then(() => {
                // console.log('aquiii')
                // console.log('se cargaron las cookies')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadMainCategories () {
            const vm = this
            vm.$store.dispatch('storefront/loadCategories').then(() => {
                // console.log('se cargaron las main categories')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadVirtualShops () {
            const vm = this
            vm.$store.dispatch('storefront/loadStores').then(() => {
                // console.log('se cargaron los virtual store')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        loadFavorites () {
            const vm = this
            vm.$store.dispatch('shops/loadFavorites').then(() => {
                // console.log('se cargaron los favoritos')
            }, function (err) {
                console.log(err, 'Permision denied error')
            })
        },
        optimize (type) {
          this.$store.dispatch('transactions/optimizeTransactions', type).then(function (data) {
            // res
            // console.log('termino!')
          })
        },
        getImage (url) {
            if (url === '') {
                return require('@/assets/icons/shop.svg')
            } else {
                return url
            }
        },
    },

    created () {
        // let vm = this;
        // // console.log('CREATED---------------------------------------------------------------')
        // firebase.auth().onAuthStateChanged(function(currentUser) {
        //     try{
        //         if (currentUser) {
        //             vm.loadCategories();
        //             vm.loadLocations();
        //             vm.loadProviders();
        //             // vm.loadExpenses();
        //             vm.loadBills();
        //             vm.loadSubscriptions();
        //             vm.loadProducts();
        //         }else{
        //             vm.clearUser();
        //         }
        //     }catch(err){
        //         //errores
        //         vm.clearUser();
        //        // console.log(err)
        //     }
        // });
    },
}
//
